import { useEffect, useState, useCallback } from "react";

// Per-shop cart kept in localStorage (guests have no account). Items: {id, title, price, qty}.
const key = (slug) => `dw_cart_${slug}`;
const EVT = "dw-cart-change";

const read = (slug) => {
  try { return JSON.parse(localStorage.getItem(key(slug)) || "[]"); } catch { return []; }
};
const write = (slug, items) => {
  try { localStorage.setItem(key(slug), JSON.stringify(items)); } catch { /* private mode: cart just won't persist */ }
  window.dispatchEvent(new CustomEvent(EVT, { detail: slug }));
};

export function useCart(slug) {
  const [items, setItems] = useState(() => read(slug));
  useEffect(() => {
    setItems(read(slug));
    const sync = (e) => { if (!e.detail || e.detail === slug) setItems(read(slug)); };
    window.addEventListener(EVT, sync);
    return () => window.removeEventListener(EVT, sync);
  }, [slug]);

  const add = useCallback((offer) => {
    const cur = read(slug);
    const hit = cur.find((i) => i.id === offer.offer_id);
    if (hit) hit.qty = Math.min(hit.qty + 1, 99);
    else cur.push({ id: offer.offer_id, title: offer.title, price: offer.price || "", price_value: offer.price_value ?? null, qty: 1 });
    write(slug, cur);
  }, [slug]);
  const setQty = useCallback((id, qty) => {
    write(slug, read(slug).map((i) => (i.id === id ? { ...i, qty } : i)).filter((i) => i.qty > 0));
  }, [slug]);
  const clear = useCallback(() => write(slug, []), [slug]);
  const count = items.reduce((n, i) => n + i.qty, 0);
  return { items, count, add, setQty, clear };
}

export const cartTotal = (items) =>
  items.every((i) => i.price_value != null) ? items.reduce((n, i) => n + Number(i.price_value) * i.qty, 0) : null;

export const canCart = (b) => !!b && (b.mode === "food" ? b.accepting_orders !== false : !!b.whatsapp);

export const cartMessage = (bizName, items, pageUrl, note) =>
  `Hi ${bizName}, I'd like to order:\n` +
  items.map((i, n) => `${n + 1}. ${i.qty} x ${i.title}${i.price ? ` (${i.price})` : ""}`).join("\n") +
  (note ? `\n\nNote: ${note}` : "") + `\n\n${pageUrl}`;
